import { render, staticRenderFns } from "./AgentLeaveForm.vue?vue&type=template&id=c31c4ece&"
import script from "./AgentLeaveForm.vue?vue&type=script&lang=js&"
export * from "./AgentLeaveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c31c4ece')) {
      api.createRecord('c31c4ece', component.options)
    } else {
      api.reload('c31c4ece', component.options)
    }
    module.hot.accept("./AgentLeaveForm.vue?vue&type=template&id=c31c4ece&", function () {
      api.rerender('c31c4ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/modals/AgentLeaveForm.vue"
export default component.exports